module.exports = __webpack_public_path__ + "img/zengqiong.a54c7736.png";